class AddToWishlistController extends window.StimulusController {
  static values = {
    customerId: Number,
    productInWishlistId: Number,
    userAccountUrl: String,
  };
  static targets = ["addToWishlistForm", "icon"];

  #toggleClasses() {
    this.iconTarget.classList.toggle("tw-fill-blue");
    this.iconTarget.classList.toggle("tw-fill-none");
  }

  async #performRequest(url, method, body = null) {
    try {
      this.iconTarget.classList.add(
        "tw-scale-125",
        "tw-transition-transform",
        "tw-duration-200",
      );
      const response = await fetch(url, {
        method,
        body,
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        return console.error(
          `Failed to perform request (method: ${method}, url: ${url})`,
          response,
        );
      }
    } catch (error) {
      return console.error("Network error", error);
    } finally {
      this.iconTarget.classList.remove(
        "tw-scale-125",
        "tw-transition-transform",
        "tw-duration-100",
      );
    }

    return this.#toggleClasses();
  }

  async toggleWishlist(event) {
    event.preventDefault();

    const customerLoggedIn = this.customerIdValue != 0;
    const productAlreadyInWishlist = this.productInWishlistIdValue != 0;

    if (!customerLoggedIn) {
      return window.location.replace(this.userAccountUrlValue);
    }

    if (productAlreadyInWishlist) {
      return this.removeProductFromWishlist();
    }

    return this.quickAdd();
  }

  async quickAdd() {
    const formData = new FormData(this.addToWishlistFormTarget);
    const url = this.addToWishlistFormTarget.action;
    const method = this.addToWishlistFormTarget.method;
    return this.#performRequest(url, method, formData);
  }

  async removeProductFromWishlist() {
    const url = `${this.addToWishlistFormTarget.action}/${this.productInWishlistIdValue}`;
    const method = "DELETE";
    return this.#performRequest(url, method);
  }
}

Stimulus.register("add-to-wishlist", AddToWishlistController);
